<template>
  <Layout>
    <template #header>
      <Heading>{{ $t('ppm_modal__add_heading') }}</Heading>
    </template>

    <template #default>
      <div class="apm-cards">
        <b-radio
          v-for="paymentMethod in availablePaymentMethods"
          :key="paymentMethod.id"
          v-model="selectedPaymentMethod"
          name="payment-method"
          :native-value="paymentMethod.id"
          :disabled="paymentMethod.disabled"
          class="apm-card-radio"
        >
          <AddPaymentCard
            class="apm-card"
            :class="[
              paymentMethod.class,
              {
                'apm-card-selected': paymentMethod.id === selectedPaymentMethod,
              },
            ]"
            :title="paymentMethod.name"
          >
            {{ paymentMethod.description }}
          </AddPaymentCard>
        </b-radio>
      </div>
    </template>

    <template #footer>
      <HotPinkButton
        data-testid="add-ppm-button"
        :disabled="!selectedPaymentMethod"
        @click="
          $emit('go-to-add-payment-method-more-info', selectedPaymentMethod)
        "
      >
        {{ $t('ppm_modal__add_confirm_button') }}
      </HotPinkButton>
      <NavyButton
        v-if="hasPaymentAccounts"
        class="add-ppm-button"
        @click="$emit('go-to-select-preferred-payment-method')"
      >
        {{ $t('nav_back') }}
      </NavyButton>
    </template>
  </Layout>
</template>

<script>
import Layout from '../layouts/Layout'
import Heading from '../typography/Heading3'
import AddPaymentCard from '../cards/AddPaymentCard'
import HotPinkButton from '../buttons/HotPinkButton'
import NavyButton from '../buttons/NavyButton'
import PaymentFlagsMixin from '../mixins/PaymentFlagsMixin'

export default {
  components: {
    Layout,
    Heading,
    AddPaymentCard,
    HotPinkButton,
    NavyButton,
  },
  mixins: [PaymentFlagsMixin],
  data() {
    return {
      hasPaymentAccounts: false,
      availablePaymentMethods: [],
      selectedPaymentMethod: null,
    }
  },
  computed: {
    paymentOptions() {
      return [
        {
          id: 'STRIPE_DIRECT_DEPOSIT',
          name: this.$t('payment_methods.direct_deposit'),
          description: this.$t('payment_methods.direct_deposit_description'),
          class: 'tw-border-[#E73656]',
        },
        {
          id: 'STRIPE_CARD_ISSUING_DIGITAL',
          name: this.$t('payment_methods.virtual_card'),
          description: this.$t('payment_methods.virtual_card_description'),
          class: 'tw-border-[#0281AC]',
        },
        {
          id: 'STRIPE_CARD_ISSUING_PHYSICAL',
          name: this.$t('payment_methods.physical_card'),
          description: this.$t('payment_methods.physical_card_description'),
          class: 'tw-border-[#A33895]',
        },
      ]
    },
  },
  created() {
    this.getAvailablePaymentMethods()
  },
  methods: {
    async getAvailablePaymentMethods() {
      this.availablePaymentMethods = await Promise.all(
        this.paymentOptions.map(async (paymentMethod) => {
          // If present, we should not support its creation again
          if (await this.isPaymentMethodPresent(paymentMethod.id)) {
            this.hasPaymentAccounts = true
            return { ...paymentMethod, disabled: true }
          }
          return { ...paymentMethod, disabled: false }
        })
      )
    },
  },
}
</script>

<style lang="postcss" scoped>
.apm-cards {
  /* Base */
  @apply tw-flex tw-flex-col tw-gap-6 tw-mx-2 tw-mt-16 tw-mb-5;

  /* Desktop */
  @apply lg:tw-items-center lg:tw-gap-8 lg:tw-mt-20 lg:tw-mb-16;
}

.apm-card-radio {
  /* Base */
  @apply !tw-m-0;
}

.apm-card-radio >>> .control-label {
  /* Base */
  @apply tw-flex-1;
}

.apm-card {
  /* Desktop */
  @apply lg:tw-w-[390px];
}

.apm-card-selected {
  /* Base */
  box-shadow: 0 0 0 2.7px #325cf3;
  filter: drop-shadow(2px 2px 4px rgba(0, 0, 0, 0.25));
}
</style>
